export default __webpack_public_path__ + "static/media/593.acda48db.png";